import { faCaretDown, faMoon, faRightFromBracket, faSun, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkAuth, getUserByID, getUserGoogle, login, logout, logoutGoogle, signup } from '~/api/api';
import {
    LoginModal,
    LoginModalTrigger,
    ResetPasswordModal,
    SignupModal,
    SignupModalTrigger,
} from '~/components/Modals/Auth';
import './header.scss';
import clsx from 'clsx';
import styles from './header.module.scss';

import $ from 'jquery';
import { getRole } from '~/api/auth';

function Header() {
    const [currentUser, setCurrentUser] = useState();
    const [currentLocation, setCurrentLocation] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [open, setOpen] = useState(false);
    let userMenuRef = useRef();
    const [isLight, setIsLight] = useState(false);

    const [role, setRole] = useState('normal');

    const handleLogout = () => {
        logout();
        window.location.href = '/';
    };

    useEffect(() => {
        (async () => {
            const fetchRole = await getRole();
            if (fetchRole.code !== 400) {
                setRole(fetchRole.body.role);
            }
        })();
    }, []);

    useEffect(() => {
        if (currentUser) {
            let handler = (e) => {
                // if (e.target) {
                if (!userMenuRef.current.contains(e.target)) {
                    setOpen(false);
                }
            };

            document.addEventListener('mousedown', handler);

            return () => {
                document.removeEventListener('mousedown', handler);
            };
        }
    });

    useEffect(() => {
        var navbarItem = $('.navbarItem');
        for (let i = 0; i < navbarItem.length; i++) {
            navbarItem[i].classList.remove('navbarActive');
        }
        const dropdownToggle = () => {
            var dropdownMenu = $('.dropdownMenu');
            if (dropdownMenu[0].classList.contains('dropdownHide')) {
                dropdownMenu[0].classList.remove('dropdownHide');
            } else {
                dropdownMenu[0].classList.add('dropdownHide');
            }
        };
        if (window.location.href === `${process.env.REACT_APP_LOCAL_WEB_URL}/`) {
            navbarItem[0].classList.add('navbarActive');
            // setCurrentLocation('home');
        } else if (window.location.href.indexOf(`/problems`) !== 0) {
            navbarItem[1].classList.add('navbarActive');
            // setCurrentLocation('problems');
        } else if (window.location.href.indexOf(`/contribute`) !== 0) {
            navbarItem[2].classList.add('navbarActive');
            // setCurrentLocation('contribute');
        }
        console.log(window.location.href);
        // setCurrentLocation();
    });

    const handleChangeDarkMode = () => {
        var currentTheme = localStorage.getItem('theme');
        if (currentTheme && currentTheme === 'dark') {
            document.documentElement.setAttribute('data-theme', 'light');
            localStorage.setItem('theme', 'light');
            setIsChecked(false);
        } else if (!currentTheme || currentTheme === 'light') {
            document.documentElement.setAttribute('data-theme', 'dark');
            localStorage.setItem('theme', 'dark');
            setIsChecked(true);
        }
    };

    useEffect(() => {
        const savedCheckedState = localStorage.getItem('theme');
        if (savedCheckedState && savedCheckedState === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
            setIsChecked(true);
        }
    }, []);

    useEffect(() => {
        (async () => {
            var session = localStorage.getItem('session');
            if (session) {
                session = JSON.parse(session);
                const authen = await checkAuth(session.accessToken);
                console.log(authen);
                if (authen.login === true) {
                    setCurrentUser(session.user);
                }
            } else {
                console.log('Here');
                const userGoogle = await getUserGoogle();
                console.log(userGoogle);
                if (userGoogle.code === 200) {
                    session = {
                        accessToken: userGoogle.body.body.accessToken,
                        user: userGoogle.body.body.user,
                    };
                    localStorage.setItem('session', JSON.stringify(session));
                    await logoutGoogle();
                    window.location.href = '../';
                }
                // session = localStorage.getItem('session');
                // if (session) {
                //     await logoutGoogle();
                //     session = JSON.parse(session);
                //     const authen = await checkAuth(session.accessToken);
                //     if (authen.login === true) {
                //         setCurrentUser(session.user);
                //     }
                // }
            }
        })();
    }, []);

    const dropdownToggle = () => {
        var dropdownMenu = $('.dropdownMenu');
        if (dropdownMenu[0].classList.contains('dropdownHide')) {
            dropdownMenu[0].classList.remove('dropdownHide');
        } else {
            dropdownMenu[0].classList.add('dropdownHide');
        }
    };

    return (
        <div>
            <div className={clsx(styles.navbar)}>
                <div className={clsx(styles.container)}>
                    <div className={clsx(styles.logoField)}>
                        <Link className={clsx(styles.navbarBrand, styles.navbarLink)} to="/">
                            <span className={clsx(styles.logoName)}>HNLCoding</span>
                        </Link>
                    </div>
                    <div className={clsx(styles.navbarNav)}>
                        <div className="navbarItem">
                            <Link className={clsx(styles.navbarLink)} to="/">
                                Home
                            </Link>
                        </div>
                        <div className="navbarItem">
                            <Link className={clsx(styles.navbarLink)} to="/problems">
                                Problems
                            </Link>
                        </div>
                        <div className="navbarItem">
                            <Link className={clsx(styles.navbarLink)} to="/contribute">
                                Contribute
                            </Link>
                        </div>
                        {role !== 'normal' && (
                            <div className="navbarItem">
                                <Link className={clsx(styles.navbarLink)} to="/courses">
                                    Courses
                                </Link>
                            </div>
                        )}
                        {/* {role !== 'normal' && (
                            <div className="navbarItem">
                                <Link className={clsx(styles.navbarLink)} to="/courses/1">
                                    Course
                                </Link>
                            </div>
                        )} */}
                    </div>
                    {currentUser && (
                        <div class={clsx(styles.dropdown)} ref={userMenuRef}>
                            <div
                                className={clsx(styles.dropdownToggle, styles.dropdownUser)}
                                onClick={() => setOpen(!open)}
                            >
                                <FontAwesomeIcon icon={faUser} />
                            </div>
                            <div className={`${open ? '' : 'dropdownHide'} dropdownMenu`}>
                                <div className={clsx(styles.dropdownItemUser)}>
                                    <div className={clsx(styles.dropdownItemAvatar)}>
                                        {currentUser.avatar && (
                                            <img
                                                src={currentUser.avatar}
                                                alt="avt"
                                                className={clsx(styles.logoImage)}
                                            ></img>
                                        )}
                                        {!currentUser.avatar && (
                                            <img
                                                src="/images/logo_v2.png"
                                                alt="avt"
                                                className={clsx(styles.logoImage)}
                                            ></img>
                                        )}
                                    </div>
                                    <div className={clsx(styles.dropdownItemUserInfo)}>
                                        <div className={clsx(styles.name)}>{currentUser.name}</div>
                                        <div className={clsx(styles.email)}>{currentUser.email}</div>
                                    </div>
                                </div>
                                <div className={clsx(styles.dropdownDivider)}></div>
                                <div className={clsx(styles.dropdownItem)}>
                                    <div className={clsx('d-flex', 'align-items-center')}>
                                        <div className={clsx(styles.dropdownItemIcon)}>
                                            <FontAwesomeIcon icon={faUser} />
                                        </div>
                                        <Link className={clsx(styles.dropdownLink)} to="">
                                            Profile
                                        </Link>
                                    </div>
                                </div>
                                <div
                                    className={clsx(
                                        styles.dropdownItem,
                                        'd-flex',
                                        'align-items-center',
                                        'justify-content-between',
                                    )}
                                >
                                    <div className={clsx('d-flex', 'align-items-center')}>
                                        <div className={clsx(styles.dropdownItemIcon)}>
                                            {!isChecked && <FontAwesomeIcon icon={faSun} />}
                                            {isChecked && <FontAwesomeIcon icon={faMoon} />}
                                        </div>
                                        Dark mode
                                    </div>
                                    <label class={clsx(styles.switch)}>
                                        <input type="checkbox" onChange={handleChangeDarkMode} checked={isChecked} />
                                        <span class={clsx(styles.slider, styles.round)}></span>
                                    </label>
                                </div>
                                <div className={clsx(styles.dropdownDivider)}></div>
                                <div className={clsx(styles.dropdownItem, styles.dropdownItem2)} onClick={handleLogout}>
                                    <div className={clsx('d-flex', 'align-items-center')}>
                                        <div className={clsx(styles.dropdownItemIcon)}>
                                            <FontAwesomeIcon icon={faRightFromBracket} />
                                        </div>
                                        Logout
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!currentUser && (
                        <div className="d-flex gap-3">
                            <div
                                className={clsx('btn', 'btn-text', styles.btnSignin)}
                                onClick={() => LoginModalTrigger.open()}
                            >
                                Log in
                            </div>
                            <div
                                className={clsx('btn', 'btn-text', styles.btnSignup)}
                                onClick={() => SignupModalTrigger.open()}
                            >
                                Sign up
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <LoginModal />
            <SignupModal />
            <ResetPasswordModal />
        </div>
    );
}

export default Header;
